import React, { useContext } from "react";
import classes from "./GamesList.module.scss";
import { useNavigate, useLocation } from "react-router";
import * as r from "../../../../constants/routes";
import PageHeader from "../../../../components/Headers/PageHeader";
import PageMain from "../../../../components/Main/PageMain";
import UserTrainingContext from "../../../../context/userTrainingContext";
import { useTranslation } from "react-i18next";
import Spinner from "../../../../components/Spinner";
import CardGame from "../../../../components/Cards/CardGame";
import { GET_PROD_OR_DEV } from "../../../../constants/api";
import CardsArea from "../../../../components/Cards/CardsArea";
import FriendlyInfo from "../../../../components/FriendlyInfo";
import { prettySubPathUrl, simplestText } from "../../../../helpers";
import CardRandomGame from "../../../../components/Cards/CardRandomGame";

export default function GamesList() {
  const tContext = useContext(UserTrainingContext);
  const { game_list, active_category, setGameUrl } = tContext ?? {};
  const { t } = useTranslation();
  const history = useNavigate();

  let _content = <Spinner center />;
  let _randomGame = null;

  const location = useLocation();
  let urlCategory = String(location.pathname.split('treinamento/')[1])
  if (urlCategory === "memoria") urlCategory = "Memória";
  if (urlCategory === "escuta-ativa") urlCategory = "Escuta Ativa";
  if (urlCategory === "agilidade-mental") urlCategory = "Agilidade Mental";
  if (urlCategory === "foco") urlCategory = "Foco";
  const activeCategoryAux = active_category ?? urlCategory;

  if (game_list && game_list.length > 0 && activeCategoryAux) {
    const filtered_game_list = game_list.filter((game: any) =>
      game.abilities.includes(activeCategoryAux)
    );
    const randomGame =
      filtered_game_list[Math.floor(Math.random() * filtered_game_list.length)];

    if (randomGame)
      _randomGame = (
        <CardRandomGame
          key={randomGame.id ?? randomGame.name}
          id={randomGame.id}
          name={randomGame.name}
          image={randomGame.images.thumb}
          abilities={randomGame.abilities}
          onClick={() => {
            history(
              prettySubPathUrl(
                r.GET_R_U_TRAIN_GAME_SCREEN(activeCategoryAux, randomGame.name)
              )
            );
            setGameUrl(
              randomGame.activity_urls[GET_PROD_OR_DEV],
              randomGame.name
            );
          }}
        />
      );

    _content = filtered_game_list.map((game: any) => (
      <CardGame
        key={game.id ?? game.name}
        id={game.id}
        name={game.name}
        image={game.images.thumb}
        abilities={game.abilities}
        onClick={() => {
          history(
            prettySubPathUrl(
              r.GET_R_U_TRAIN_GAME_SCREEN(activeCategoryAux, game.name)
            )
          );
          setGameUrl(game.activity_urls[GET_PROD_OR_DEV], game.name);
        }}
      />
    ));
    _content = (
      <>
        {_randomGame}
        <CardsArea className={classes.CorrectionTop}>{_content}</CardsArea>
      </>
    );
  } else if (game_list && game_list.length === 0) {
    _content = (
      <FriendlyInfo
        isError
        text={t("infos.error_to_fetch_info_try_to_reload")}
      />
    );
  }

  let title = "";
  let subtitle = "";
  switch (simplestText(activeCategoryAux)) {
    case simplestText("Escuta Ativa"):
      title = "global.title_escuta_ativa";
      subtitle = "global.subtitle_escuta_ativa";
      break;
    case simplestText("Memória"):
      title = "global.title_memoria";
      subtitle = "global.subtitle_memoria";
      break;
    case simplestText("Foco"):
      title = "global.title_foco";
      subtitle = "global.subtitle_foco";
      break;
    case simplestText("Agilidade Mental"):
      title = "global.title_agilidade_mental";
      subtitle = "global.subtitle_agilidade_mental";
      break;
    default:
      title = "global.training";
      break;
  }
  return (
    <>
      <PageHeader
        title={t(title)}
        subtitle={t(subtitle)}
        textInfo={t("global.info_text_goal_by_day")}
        btnTitle={t("global.back")}
        btnText={t("global.back")}
        btnClick={() => {
          tContext.setActiveCategory(null);
          history("/");
        }}
      />
      <PageMain centerStretch>
        <section className={classes.TabTraining}>{_content}</section>
      </PageMain>
    </>
  );
}
